import { ColorTheme, ColorToken } from 'styles/colorThemes/colorThemeTypes';

export const lightTheme: ColorTheme = {
  [ColorToken.primary]: '#45434f',
  [ColorToken.secondary]: '#fff',
  [ColorToken.greyPrimary]: '#f7f7f7',
  [ColorToken.greySecondary]: '#ccc',
  [ColorToken.interactiveHiglightInactive]: 'rgba(69, 67, 79, 0)',
  [ColorToken.interactiveHiglightHover]: 'rgba(69, 67, 79, 0.8)',
  [ColorToken.interactiveHiglightActive]: 'rgba(69, 67, 79, 1)',

  // brinkbit design theme
  [ColorToken.brinkbitBlue]: '#60aecc',
  [ColorToken.brinkbitPrimary]: '#050f17',
  [ColorToken.brinkbitSecondary]: '#fff',
  [ColorToken.brinkbitGreyPrimary]: '#bfced6',
  [ColorToken.brinkbitGreySecondary]: '#587687',

  // spark design theme
  [ColorToken.sparkPrimary]: '#081f2c',
  [ColorToken.sparkSecondary]: '#fff',
  [ColorToken.sparkGreyPrimary]: '#bfced6',
  [ColorToken.sparkGreySecondary]: '#000',
  [ColorToken.sparkGreyTertiary]: '#5f717d',
  [ColorToken.sparkGradient1]: '#e08e26',
  [ColorToken.sparkGradient2]: '#b84a21',
  [ColorToken.sparkGradient3]: '#c25823',
  [ColorToken.sparkGradient4]: '#bb4d1e',
  [ColorToken.sparkGradient5]: '#a82f11',
  [ColorToken.sparkGradient6]: '#941103',
  [ColorToken.sparkGradient7]: '#731001',
  [ColorToken.sparkGradient8]: '#9e1708',
  [ColorToken.sparkGreyGradient1]: '#a8a8a8',
  [ColorToken.sparkGreyGradient2]: '#666',
  [ColorToken.sparkGreyGradient3]: '#828282',
  [ColorToken.sparkGreyGradient4]: '#777',
  [ColorToken.sparkGreyGradient5]: '#595959',
  [ColorToken.sparkGreyGradient6]: '#363636',
  [ColorToken.sparkGreyGradient7]: '#474747',
  [ColorToken.sparkGreyGradient8]: '#707070',
  [ColorToken.sparkMonoOrange]: '#bc4729',
  [ColorToken.sparkMonoOrangeDesaturated]: '#bcbcbc',
  [ColorToken.sparkMonoRed]: '#9a3322',
  [ColorToken.sparkMonoRedDesaturated]: '#9a9a9a',
  [ColorToken.sparkMonoYellow]: '#d2892d',
  [ColorToken.sparkMonoYellowDesaturated]: '#d2d2d2',

  // hitchd design theme
  [ColorToken.hitchdPink]: '#fe5168',
  [ColorToken.hitchdOrange]: '#ff6160',
  [ColorToken.hitchedLargeColorFill]: '#fe5168',
  [ColorToken.hitchdSecondary]: '#fff',
  [ColorToken.hitchdPinkDesaturated]: '#c4c4c4',
  [ColorToken.hitchdGreyPrimary]: '#e3e3e3',
};
